import { WorkspaceState, WorkspaceStateStatus } from '../workspaceState';

export function getGlobalWorkspace(params: string): Promise<WorkspaceState> {
  return Promise.resolve({
    status: WorkspaceStateStatus.READY,
    error: null,
    isGlobal: true,
    idWorkspace: null,
  });
}
